"use client";

import { createContext, useContext, type ReactNode } from "react";

/**
 * Whether the job's SSE pipeline stream (`useJobPipelineEvents`) is currently
 * connected. Provided once at the job layout and consumed by polling hooks
 * mounted deeper in the tree (e.g. `useNeedsMerge` in the pipeline toolbar) so
 * they can stand their intervals down while the stream drives updates.
 *
 * Defaults to `false` outside a provider — a hook with no stream context simply
 * keeps polling, which is the safe fallback.
 */
const JobPipelineStreamContext = createContext<boolean>(false);

export function JobPipelineStreamProvider({
  connected,
  children,
}: {
  connected: boolean;
  children: ReactNode;
}) {
  return (
    <JobPipelineStreamContext.Provider value={connected}>
      {children}
    </JobPipelineStreamContext.Provider>
  );
}

export function useJobPipelineStreamConnected(): boolean {
  return useContext(JobPipelineStreamContext);
}
